import styled from "styled-components";
import { $SearchPageTemplate } from "../styles";

const $OrderSearch = styled<any>($SearchPageTemplate)`
`;

export default $OrderSearch